import { render, staticRenderFns } from "./AvatarMember.vue?vue&type=template&id=c877ef00"
import script from "./AvatarMember.vue?vue&type=script&lang=js"
export * from "./AvatarMember.vue?vue&type=script&lang=js"
import style0 from "./AvatarMember.vue?vue&type=style&index=0&id=c877ef00&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports